/* 字典数据，从后端获取 */
const state = {
  dictionaries: {}
}

const mutations = {
  setDictionaries (state, data) {
    console.log('set dict items')
    for (let i = 0; i < data.length; i++) {
      let row = data[i]
      let items = []
      row.items.map(item => {
        let value = Number(item.value)
        if (!isNaN(value)) {
          items.push({
            value: item.value * 1,
            name: item.name,
            selectFlag: item.selectFlag
          })
        } else {
          items.push({
            value: item.value,
            name: item.name,
            selectFlag: item.selectFlag
          })
        }
      })
      // console.log(items)
      // state.dictionaries[row.name] = row.items
      state.dictionaries[row.name] = items
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dictionary.js